import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  NB_WINDOW,
  NbDialogService,
  NbMenuItem,
  NbMenuService,
  NbPopoverDirective,
} from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ParkbaseStorageService } from '../../services/parkbaseStorage.service';
import { MainMenuConfig } from './main-menu.config';
import { NbAccessChecker } from '@nebular/security';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit, OnDestroy {
  mainMenuItems: NbMenuItem[] = [];
  loginMenuItems: NbMenuItem[] = [];
  items: NbMenuItem[] = [];

  userName = '';
  @ViewChild(NbPopoverDirective) popover!: NbPopoverDirective;
  private subscription!: Subscription;
  private translationA!: Subscription;
  private translationB!: Subscription;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private authService: AuthService,
    private dialogService: NbDialogService,
    private parkbaseStorageService: ParkbaseStorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private accessChecker: NbAccessChecker,
    @Inject(NB_WINDOW) private window: any
  ) {}

  ngOnInit(): void {
    const mainMenuConfig = new MainMenuConfig();

    this.items = mainMenuConfig.items;
    this.mainMenuItems = mainMenuConfig.mainMenuItems;
    this.loginMenuItems = mainMenuConfig.loginMenuItems;

    this.mainMenuItems.forEach((item) => {
      this.accessChecker.isGranted('manage', 'statusPage').subscribe((result: boolean) => {
        if (item.link === '/status/facilities' && result) {
          item.hidden = false;
        }
      });
      this.accessChecker
        .isGranted('manage', 'identificationValidation')
        .subscribe((result: boolean) => {
          if (item.link === '/identification/validation' && result) {
            item.hidden = false;
          }
        });
      this.accessChecker
        .isGranted('manage', 'bulkTransactionClose')
        .subscribe((result: boolean) => {
          if (item.link === '/transactions' && result) {
            item.hidden = false;
          }
        });
      this.accessChecker.isGranted('manage', 'apiSettings').subscribe((result: boolean) => {
        if (item.link === '/settings' && result) {
          item.hidden = false;
        }
      });
      this.accessChecker.isGranted('manage', 'apiAccess').subscribe((result: boolean) => {
        if (item.link === '/settings' && result) {
          item.hidden = false;
        }
      });
    });

    this.userName = this.parkbaseStorageService.retrieveUserSessionId()?.preferred_username;

    this.menuTranslation();

    this.subscription = this.translate.onLangChange.subscribe((lang) => {
      if (lang) {
        this.menuTranslation();
        this.changeDetectorRef.detectChanges();
      }
    });

    const currentRoute = this.router.url.split('/')[1];
    this.mainMenuItems.forEach((i) => {
      if (i.link) {
        const currentLinkRoute = i.link.split('/')[1];
        i.selected = i.link === '/' + currentRoute || currentLinkRoute === currentRoute;
      }
    });
    this.loginMenuItems.forEach((i) => {
      i.selected = i.url === '/' + currentRoute;
    });
  }

  openNotificationsOverlay(notificationsDialog: TemplateRef<any>) {
    this.dialogService.open(notificationsDialog, {
      context: {
        facilitySelection: 'divisionsNotifications',
        showCloseButtonForMobile: true,
      },
    });
  }

  close() {
    this.popover.hide();
  }

  profileActive() {
    if (this.router.url === '/profile') {
      return 'profile-active';
    } else {
      return '';
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.translationA.unsubscribe();
    this.translationB.unsubscribe();
  }

  onHoverItem(menuItem: NbMenuItem) {}

  onItemClick(index: number) {
    this.mainMenuItems.forEach((i) => {
      i.selected = false;
    });
    this.mainMenuItems[index].selected = true;
  }

  private menuTranslation() {
    let index = 0;
    this.translationA = this.translate.getTranslation(this.translate.currentLang).subscribe((d) => {
      for (const item in d['GLOBAL_NAVIGATION']) {
        if (this.mainMenuItems[index]) {
          this.mainMenuItems[index].title = d['GLOBAL_NAVIGATION'][item];
          index++;
        }
      }
    });
    let index2 = 0;
    this.translationB = this.translate.getTranslation(this.translate.currentLang).subscribe((d) => {
      for (const item in d['ACCOUNT_NAVIGATION']) {
        if (this.loginMenuItems[index2]) {
          this.loginMenuItems[index2].title = d['ACCOUNT_NAVIGATION'][item];
          index2++;
        }
      }
    });
  }
}
